import { Component, EventEmitter, Output, inject } from '@angular/core';
import {
  NgbModal,
  NgbOffcanvas,
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownItem,
  NgbDropdownButtonItem,
} from '@ng-bootstrap/ng-bootstrap';
import { LogComponent } from 'src/app/log/log.component';
import { SignComponent } from 'src/app/sign/sign.component';
import { Store } from '@ngrx/store';
import {
  selectReqFieldCounter,
  selectIsSubmittingWithNoErrors,
  selectLogCount,
  selectDisableSubmitButton,
  selectIsNotInProgress,
} from 'src/app/state/form.selectors';
import { DataService } from 'src/app/services/data.service';
import { NavigationExtras, Router } from '@angular/router';
import { resetState } from 'src/app/state/form.actions';
import { MessageBoxState } from 'src/app/models/MessageBoxState';
import { NgClass, AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownButtonItem,
    NgClass,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class FooterComponent {
  private readonly offcanvasService = inject(NgbOffcanvas);
  private readonly modalService = inject(NgbModal);
  private readonly store = inject(Store);
  private readonly dataService = inject(DataService);
  private readonly router = inject(Router);

  reqFieldCounter$ = this.store.select(selectReqFieldCounter);
  disableSubmitButton$ = this.store.select(selectDisableSubmitButton);
  isNotInProgress$ = this.store.select(selectIsNotInProgress);
  showButtonSpinner$ = this.store.select(selectIsSubmittingWithNoErrors);
  logCount$ = this.store.select(selectLogCount);

  @Output() showAuthor = new EventEmitter<boolean>();
  displayItemAuthor = true;

  toggleAuthor(event) {
    this.displayItemAuthor = event.target.checked;
    this.showAuthor.emit(this.displayItemAuthor);
  }

  viewLogs() {
    this.offcanvasService.open(LogComponent, {
      position: 'end',
    });
  }

  signAndSubmit() {
    this.modalService.open(SignComponent, {
      centered: true,
    });
  }

  logout() {
    this.dataService.logout();
    this.store.dispatch(resetState());
    const navigationExtras: NavigationExtras = {
      state: MessageBoxState.Logout,
      skipLocationChange: true,
    };
    this.router.navigateByUrl('message-box', navigationExtras);
  }
}
